import { render, staticRenderFns } from "./NuevoAlmacen.vue?vue&type=template&id=6f1a8ede&scoped=true"
import script from "./NuevoAlmacen.vue?vue&type=script&lang=js"
export * from "./NuevoAlmacen.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "spinkit/spinkit.min.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./NuevoAlmacen.vue?vue&type=style&index=2&id=6f1a8ede&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1a8ede",
  null
  
)

export default component.exports